module.exports = __webpack_public_path__ + "static/image/logo-family/logo_takeout@3x.png?c77a8e8e";